import React from "react";
import PropTypes from "prop-types";
import { Droppable } from "react-beautiful-dnd";

export const withDroppable = Component => {
  class WithDroppable extends React.Component {
    render() {
      const { droppableId, isDraggableTable } = this.props;
      return isDraggableTable ? (
        <Droppable droppableId={droppableId}>
          {provided => {
            const droppableProps = {
              ...provided.droppableProps,
              placeholder: provided.placeholder,
            };
            return (
              <Component
                {...this.props}
                droppableProps={droppableProps}
                ref={provided.innerRef}
              />
            );
          }}
        </Droppable>
      ) : (
        <Component {...this.props} />
      );
    }
  }
  WithDroppable.propTypes = {
    droppableId: PropTypes.string,
    isDraggableTable: PropTypes.bool,
  };

  return WithDroppable;
};
